module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/root.240b6abc2c7f4b80a415c9e5e8e81251-ccahPlaceHolder-d1800.jpg";